import React from 'react'
import {withStyles} from '@material-ui/core/styles'
import {ThemeProvider} from '@material-ui/core/styles'
import {theme} from 'theme'
import MenuView from 'components/Menu/MenuView'
import {useParams, Redirect} from 'react-router-dom'
import {Helmet} from 'react-helmet'

const styles = theme => ({

})

const MenuLanguageSwitch = withStyles(styles)(({classes, ...props}) => {
  const {lang} = useParams()
  return <>
    <Helmet htmlAttributes={{ lang: lang }}/>
    <ThemeProvider theme={theme}>
        <MenuView lang={lang}/>
        {lang !== 'gr' && lang !== 'en' && lang !=='fr' && lang !=='de'? <Redirect to={'/'}/> : null}
    </ThemeProvider>
  </>
})

export default MenuLanguageSwitch